import React, { Suspense,useEffect } from 'react';

import './App.css';
import SiteRouting from './routing/SiteRouting';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AuthProvider } from "react-auth-kit";
import { Provider } from 'react-redux';
import store from './redux/ConfigureStore';
import loadingImg from './assets/images/wdLoading.gif';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import '@splidejs/splide/dist/css/splide.min.css';
import i18n from './i18n';

function App() {
  function LocaleSync() {
    const location = useLocation();
    useEffect(() => {
      const seg = (location.pathname.split('/').filter(Boolean)[0] || '').toLowerCase();
      // Normalize legacy or wrong codes
      const normalizeMap = {
        'id-id': 'in-id',
      };
      if (normalizeMap[seg]) seg = normalizeMap[seg];
      const lng = /^[a-z]{2}-[a-z]{2}$/.test(seg) ? seg : 'en-us';
      if ((i18n.language || '').toLowerCase() !== lng) {
        i18n.changeLanguage(lng);
        document.documentElement.setAttribute('lang', lng);
      }
    }, [location.pathname]);
    return null;
  }


  return (
    <Suspense fallback={<div style={{ minHeight: 'calc(100vh - 32px)' }} className="flex items-center justify-center h-full"><img className="py-1.5" src={loadingImg} alt="western digital" /></div>}>
      <Provider store={store}>
        <Header />
        <div role="main" className="mainContainWrap" style={{ minHeight: 'calc(100vh - 32px)' }}>
          <AuthProvider
            authCookieName={"cookie"}
            authTimeCookieName={"timecookie"}
            stateCookieName={"statecookie"}
            authType={'statecookie'}
            authName={'_auth'}
            cookieDomain={window.location.hostname}
            cookieSecure={window.location.protocol === "http:"}>
            <BrowserRouter>
              <LocaleSync />
              <SiteRouting />
            </BrowserRouter>
          </AuthProvider>
        </div>
        <Footer />
      </Provider>
    </Suspense>
  );
}

export default App;

